<div d-flex align-items-end flex-column>
    <div class="modal-header">
        <h4 class="modal-title">SETTINGS</h4>
        <button type="button" class="icon-btn px-ml-5 md-18 md-light" aria-label="Close"
            (click)="activeModal.dismiss('Cross click')">
        </button>
    </div>
    <div class="modal-body d-flex flex-row">
        <div class="d-flex flex-column setting-tab-panel">

            <div class="px-p-10" *ngIf="isSuperAdmin()" (click)="userDetailsSelected = false; userSelected = true;"
                [ngClass]="{'active-setting-tab': !userDetailsSelected && userSelected}">
                Add / Remove User
            </div>
            <div class="px-p-10" *ngIf="isSuperAdmin()" (click)="userDetailsSelected = true; userSelected = true;"
                [ngClass]="{'active-setting-tab': userDetailsSelected && userSelected}">
                User Details
            </div>
            <div class="px-p-10" (click)="tailProbabilitySelected = true; userSelected = false;"
                [ngClass]="{'active-setting-tab': tailProbabilitySelected && !userSelected}">
                Tail Probability
            </div>
            <div class="px-p-10" (click)="tailProbabilitySelected = false; userSelected = false; refreshCache = false; refreshCache = false;"
                [ngClass]="{'active-setting-tab': !tailProbabilitySelected && !userSelected && !refreshCache }">
                Rollover
            </div>
          <div class="px-p-10" *ngIf="isSuperAdmin()" (click)="tailProbabilitySelected = false; userSelected = false;  refreshCache = true;"
                [ngClass]="{'active-setting-tab': !tailProbabilitySelected && !userSelected && refreshCache}">
                Refresh Cache
            </div>
        </div>
        <div class="d-flex flex-column px-p-10 w-100">
            <!--user-setting-content-panel"-->
            <!--<div [class.d-none]="!tailProbabilitySelected && userSelected">  -->
            <div *ngIf="tailProbabilitySelected && !userSelected ">
                <div>
                    <p>Set the tail probability for each legal entity.</p>
                </div>
                <div class="tail-config-container">
                    <app-entity-tail-configs [entityTailConfigs]="rawUser.queryConfig.entityTailConfigs">
                    </app-entity-tail-configs>
                </div>
            </div>
            <!-- <div [class.d-none]="tailProbabilitySelected && userSelected"> -->
                <div *ngIf="!tailProbabilitySelected && !userSelected && !refreshCache">
                    <div class="d-flex flex-row">
                        <div>
                            <input type="radio" id="modelRollOverControl1" name="rolloverToCash"
                                [(ngModel)]="queryConfig.rolloverToCash" [value]="true">    
                            <label for="modelRollOverControl1">Rollover to cash</label>
                        </div>
    
                        <div class="px-ml-20">
                            <input type="radio" id="modelRollOverControl2" name="rolloverToCash"
                                [(ngModel)]="queryConfig.rolloverToCash" [value]="false">
                            <label for="modelRollOverControl2">No rollover</label>
                        </div>
                    </div>
                </div>
            <!-- <div [class.d-none]="!userDetailsSelected && !userSelected"> -->
            <div *ngIf="userDetailsSelected && userSelected">
                <h5>User Details</h5>
                <div id="userIdEntry"
                    class="input-group input-group-sm mb-3 align-items-center justify-content-between">
                    <select class="custom-select form-select form-select-sm" [(ngModel)]="tmpUserId">
                        <option *ngFor="let user of uidList" [value]="user">{{ user }}</option>
                    </select>
                    <div class="input-group-append px-p-10">
                        <button class="btn btn-basic" type="button" (click)="getUser(tmpUserId)">Show details</button>
                    </div>
                </div>
                <h5>Role</h5>
                <div class="input-group input-group-sm mb-3 align-items-center justify-content-between">
                    <select class="custom-select form-select form-select-sm" [(ngModel)]="selectedRoleString">
                        <option value="" disabled selected>Select a role</option>
                        <!-- <option *ngFor="let r of rolesList" [value]="r.roleID">{{ r.roleID }}</option> -->
                        <option *ngFor="let r of roles" [value]="r">{{ r }}</option>
                    </select>
                    <div class="input-group-append px-p-10">
                        <button class="btn btn-basic btn-sm" type="button" (click)="updateRole()" [disabled]="false">Add
                            role</button>
                    </div>
                </div>
                <label>Effective roles : </label>
                <div class="d-flex flex-row px-p10">
                    <div *ngIf="rawUserSelected.roles && rawUserSelected.roles.length !== 0" class="px-px-4">
                        <ul class="list-inline">
                            <li class="list-inline-item" *ngFor="let role of splitItem(rawUserSelected.roles)">{{
                                role | uppercase }}</li>
                        </ul>
                    </div>
                </div>
                <br>
                <div
                    *ngIf="rawUserSelected.roles && rawUserSelected.roles.length === 0;then no_role_available else role_available ">
                </div>
                <ng-template #no_role_assigned><label>No role assigned</label></ng-template>
                <ng-template #role_assigned><label>{{ rawUserSelected?.roles }}</label></ng-template>

                <br>
                <label>USER LIST: </label>
                <div
                    *ngIf="usersRolesList && usersRolesList.length;then usersListnotEmptyTemplate else usersListEmptyTemplate">
                </div>
                <ng-template #usersListEmptyTemplate let-modal>
                    <label>User list empty</label>
                </ng-template>
                <ng-template #usersListnotEmptyTemplate let-modal>
                    <ul class="list-group list-group-flush list-group-sm users-list-group overflow-auto">
                        <li class="list-group-item d-flex justify-content-between flex-row px-py-5"
                            *ngFor="let user of usersRolesList">
                            <div class="px-pl-15">
                                <p>{{ user.uid }} <small class="px-pl-15">{{ user.lastName | uppercase }} {{
                                        user.firstName | uppercase }}</small></p>
                            </div>
                            <div class="align-items-center  me-2">
                                <small class=" align-items-center me-1">
                                    {{ user.role | uppercase }}
                                </small>
                                <span class='logo-btn-small close closebtn' (click)="deleteUser(user.uid,user.role)">
                                </span>

                            </div>
                        </li>
                    </ul>
                </ng-template>
            </div>

            <!-- <div [class.d-none]="userDetailsSelected && !userSelected"> -->
            <div *ngIf="!userDetailsSelected && userSelected" class="scroll-y">
                <!-- Add User By CLone or not-->
                <form>
                    <h5>Create User</h5>
                    <br>
                    <div class="d-flex flex-row align-items-center justify-content-between">
                        <label for="inputUserID" class="px-px-4">UID</label>
                        <input type="text" class="px-px-4" placeholder="Enter the user ID" id="inputUserID"
                            [(ngModel)]="newUser" [ngModelOptions]="{standalone: true}" maxlength="15" required>

                        <label for="inputLastName" class="px-px-4">Cloned User ID</label>
                        <select (change)="getSelectedClonedUser($event.target.value)"
                            class="custom-select cloned-user-select-list" placeholder="Enter the user to clone"
                            [(ngModel)]="clonedUser" name="clone">
                            <option [value]="None" selected>None</option>
                            <option *ngFor="let user of uidList" [value]="user">{{ user }}</option>
                        </select>
                    </div>
                    <br><br>
                    <div class="d-flex flex-row align-items-center justify-content-between">
                        <label for="inputNewFirstName" class="px-px-4">First Name</label>
                        <input type="text" class="px-px-4" id="inputNewFirstName" [(ngModel)]="newUserObject.firstName"
                            maxlength="25">
                        <label for="inputNewLastName" class="px-px-4">Last Name</label>
                        <input type="text" class="px-px-4" id="inputNewLastName" [(ngModel)]="newUserObject.lastName"
                            maxlength="25">
                    </div>
                    <br>

                    <h5>Role</h5>
                    <div class="input-group input-group-sm mb-3 align-items-center justify-content-between">
                        <select class="custom-select form-select form-select-sm"
                            [(ngModel)]="selectedNewUSerRoleString">
                            <option value="" disabled selected>Select a role</option>
                            <!-- <option *ngFor="let r of rolesList" [value]="r.roleID">{{ r.roleID }}</option> -->
                            <option *ngFor="let r of roles" [value]="r">{{ r }}</option>
                        </select>
                        <div class="input-group-append px-p-10">
                            <button class="btn btn-basic btn-sm" type="button" (click)="updateNewUserRole()"
                                [disabled]="false">Add role</button>
                        </div>
                    </div>
                    <label>Effective roles : </label>
                    <div class="d-flex flex-row px-p10">
                        <div *ngIf="newUserObject.roles && newUserObject.roles.length !== 0" class="px-px-4">
                            <ul class="list-inline">
                                <li class="list-inline-item" *ngFor="let role of splitItem(newUserObject.roles)">
                                    {{ role | uppercase }}
                                    <span class="closebtn" (click)="deleteRoleItem(role)">&times;</span>
                                </li>

                            </ul>
                        </div>
                    </div>
                    <br>
                    <ng-template #no_role_available><label>No role assigned</label></ng-template>

                    <button class="btn btn-sm btn-basic px-w-75" type="submit" (click)="createUser(newUser, clonedUser)"
                        [disabled]="!newUser">Submit</button>
                </form>
                <p class="color-bnpp-error" *ngIf="isNewUserSubmited">Press SAVE button to complete the new user
                    submission</p>
                <br><br>

                <h5>Legal Entities</h5>
                <div>
                    <select class="custom-select form-select form-select-sm" multiple [(ngModel)]="selectedEntities"
                        id="currentEntities">
                        <option *ngFor="let entity of rawUserSelected.legalEntities" [value]="entity">{{ entity.dataName
                            }}</option>
                    </select>
                </div>

                <!-- Refresh cache-->
            </div>
            <div *ngIf="!tailProbabilitySelected && !userSelected && refreshCache" class="divCleanCache">
                <button class="buttonCleanCache" (click)="showConfirmationPopup()">Clean Cache</button>
            </div>
            <div id="confirmationPopup" class="modal">
                    <div class="modal-content">
                      <p>Are you sure you want to refresh the cache ?</p>
                      <button class="confirmButton" (click)="confirmCleanCache()">Yes</button>
                      <button class="declineButton" (click)="cancelCleanCache()">No</button>
                    </div>
                </div>
        </div>
    </div>
    <div class="modal-footer mt-auto">
        <button type="button" class="btn btn-sm btn-basic" (click)="activeModal.dismiss('Close click')">CANCEL</button>
        <button type="button" class="btn btn-sm btn-basic bnpp-btn px-w-75" (click)="onSaveSetting()">SAVE</button>
    </div>
</div>